import { render, staticRenderFns } from "./simLoginLaochang.vue?vue&type=template&id=73fc30a5&scoped=true&"
import script from "./simLoginLaochang.vue?vue&type=script&lang=js&"
export * from "./simLoginLaochang.vue?vue&type=script&lang=js&"
import style0 from "./simLoginLaochang.vue?vue&type=style&index=0&id=73fc30a5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fc30a5",
  null
  
)

export default component.exports